<template>
  <div>
    <div v-if="show">
      <template v-if="$has('FWS-NXDD-BKJL-QRQX')">
        <el-button
          class="table-button table-button-success" icon="el-icon-success" @click="handleOperateState(1, current)"
          v-track
          trackCode='reverseSupplementList-3'
        >
          确认
        </el-button>
        <el-button
          class="table-button table-button-danger" icon="el-icon-error" @click="handleOperateState(3, current)"
          v-track
          trackCode='reverseSupplementList-4'
        >
          取消
        </el-button>
      </template>
    </div>
    <operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="paramsObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="handleOperate"
    />
  </div>
</template>

<script>
import { setSupplementOperate } from '@/api/supplement';

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOperateStateShow: false,
      paramsObj: {},
      textConfig: {},
      submitLoading: false,
    };
  },
  methods: {
    handleOperateState(operation, row) {
      this.paramsObj = {
        suppleOrderNo: row.suppleOrderNo,
        operation,
      };
      const list = {
        1: {
          title: '提示',
          messageTip: '是否确认该补款记录',
          isPass: true,
        },
        3: {
          title: '提示',
          messageTip: '是否取消，取消后无法撤销',
          isPass: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    async handleOperate(params) {
      try {
        this.submitLoading = true;
        await setSupplementOperate(params);
        this.$message.success('操作成功！');
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.$emit('success');
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
  },
};
</script>
